module.exports = __webpack_public_path__ + "i18n/ja.98a14b2627e5e09a242466b8c8c13568.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/ja.json
// module id = 1541
// module chunks = 60